export let insIinitialFilterState = {
  providerIds: "",
  month: null,
  year: "2024",
  clients: [],
  page: 1,
  rows: 10,
  sortDirection: "DESC",
  isPayoutStatus: true,
  caseNo: "",
  requestStatusId: null
};
export const initReceivablesState = {
  month: null,
  year: null,
  clients: [],
  SortDirection: "DESC",
  page: 1,
  rows: 10,
};
const today = new Date();

const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-indexed month, so add 1
const day = String(today.getDate()).padStart(2, '0');

export const formattedDate = `${year}-${month}-${day}`;
export const initPendingReceivablesState = {
  "page": 1,
  "rows": 10,
  "SortDirection": "DESC",
  "billingType": "All",
  "basedOn": "Closed Date",
  "asOnDate": formattedDate,
  "clients": [
  ],
  "isInvoiceDetails": false,
  "isExportToExcel": false
};

export const initDashboardFilter = {
  month: null,
  year: "2024",
  clients: [
  ],
  page: 1,
  rows: 10,
  sortDirection: "DESC",
  caseNo: "",
  requestStatusId: null
}

export const funnelCard = [
  {
    header: "Total Billing",
    img: "../images/rupee-indian.png",
    value: "totalPayouts",
  },
  {
    header: "Total Client",
    img: "../images/totalProvider.png",
    value: "totalClient",
  },
  {
    header: "Billing Closed Cases",
    img: "../images/totalAppointment.png",
    value: "totalApppointments",
  },
  {
    header: "Unsuccessful Closed cases",
    img: "../images/unsuccessfulAppointment.png",
    value: "unSuccessfullAppointments",
  },
];
export const StatusQueFunnel = [
  {
    header: "Total Cases",
    img: "../images/totalAppointment.png",
    value: "totalCases",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "-1",
  },
  {
    header: "Total Closed Cases",
    img: "../images/totalAppointment.png",
    value: "totalClosedCases",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "17",
  },
  {
    header: "Billing Closed Cases",
    img: "../images/totalAppointment.png",
    value: "totalApppointments",
    requestStatusId: null,
    isPayoutStatus: true,
    isBillingDetails: true,
  },
  {
    header: "Billing Unsuccessful Cases",
    img: "../images/totalAppointment.png",
    value: "unSuccessfullAppointments",
    requestStatusId: null,
    isPayoutStatus: false,
    isBillingDetails: true,
    requestStatusId: null,
  },
  {
    header: "Partial Show Cases",
    img: "../images/totalAppointment.png",
    value: "partialShow",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "4",
  },
  {
    header: "Report In QC",
    img: "../images/totalAppointment.png",
    value: "reportInQC",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "12",
  },
  {
    header: "Report On Hold",
    img: "../images/totalAppointment.png",
    value: "reportOnHold",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "14",
  },
  {
    header: "Cancelled cases",
    img: "../images/totalAppointment.png",
    value: "cancelledCases",
    isPayoutStatus: false,
    isBillingDetails: false,
    requestStatusId: "10",
  },
];

export const formatInCrores = (number) => {
  if (number >= 10000000) {
    const croreValue = Math.floor(number / 10000000);
    const remainder = number % 10000000;

    const formattedRemainder = remainder.toLocaleString('en-IN');
    return `${croreValue} Cr ${formattedRemainder}`;
  } else {
    return number.toString();
  }
}